import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';
import { LayoutProps, SpaceProps, layout, space } from 'styled-system';

export const FormContainer = styled.div<LayoutProps & SpaceProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${tokens.colors.white};
  max-width: 910px;
  width: 100%;
  border-top: ${tokens.space.smallest} solid ${tokens.colors.primary};
  border-radius: ${tokens.radii.m};
  box-shadow: 0px 10px 26px rgba(64, 64, 64, 0.1);
  padding: 40px ${tokens.space.regular} 210px;
  box-sizing: border-box;

  ${layout};
  ${space};
`;
